import React from "react"
import { graphql } from "gatsby"
import ArticleTeasers from "./article-teaser"

export const query = graphql`
  fragment ArticlesTeaserFields on DatoCmsArticlesTeaser {
    id
    componentId: key
    model {
      apiKey
    }
    title
    headline
    articleType
    tags {
      id
      name
    }
    categories {
      id
      name
    }
    selectedArticles {
      id
      key
      title
      articleType
      slug
      publishedDate(formatString: "D MMMM, YYYY")
      categories {
        id
        name
      }
      tags {
        id
        name
      }
      image {
        url(imgixParams: { w: "800" })
        focalPoint {
          x
          y
        }
      }
    }
  }
`

const filterByArticleType = (
  articles: Queries.ArticleTeaserFieldsFragment[],
  articleType: string,
): Queries.ArticleTeaserFieldsFragment[] => {
  return articleType && articleType !== "All"
    ? articles.filter(article => article.articleType === articleType)
    : articles
}

const filterByCategories = (
  articles: Queries.ArticleTeaserFieldsFragment[],
  categories: { id: string; name?: string }[] = [],
): Queries.ArticleTeaserFieldsFragment[] => {
  const categoryIds = categories.map(category => category.id)
  return categoryIds.length
    ? articles.filter(article => {
        const articleCategoryIds =
          article.categories?.map(category => category.id) || []
        return articleCategoryIds.some(categoryId =>
          categoryIds.includes(categoryId),
        )
      })
    : articles
}

const filterByArticleTag = (
  articles: Queries.ArticleTeaserFieldsFragment[],
  tags: { id: string; name?: string }[] = [],
): Queries.ArticleTeaserFieldsFragment[] => {
  const tagNames = tags.map(tag => tag.name).filter(Boolean)
  return tagNames.length
    ? articles.filter(article => {
        const articleTagNames = article.tags?.map(tag => tag.name) || []
        return articleTagNames.some(tagName => tagNames.includes(tagName))
      })
    : articles
}

export interface ArticlesTeaserProps
  extends Queries.ArticlesTeaserFieldsFragment {
  articles: Queries.ArticleTeaserFieldsFragment[]
  prioritizedArticles?: Queries.ArticleTeaserFieldsFragment[]
  selectedArticles?: Queries.ArticleTeaserFieldsFragment[]
}

const ArticlesTeaser = ({
  componentId,
  title,
  headline,
  articleType,
  tags = [],
  categories = [],
  articles,
  prioritizedArticles,
  selectedArticles,
}: ArticlesTeaserProps) => {
  const articlesFilteredByType = filterByArticleType(articles, articleType)
  const articlesFilteredByCategory = filterByCategories(
    articlesFilteredByType,
    categories,
  )
  const articlesFilteredByTags = filterByArticleTag(
    articlesFilteredByCategory,
    tags,
  )

  let articlesFiltered = articlesFilteredByTags

  if (selectedArticles && selectedArticles.length) {
    articlesFiltered = selectedArticles.concat(articlesFiltered).slice(0, 3)
  }

  const articlesToShow = prioritizedArticles
    ? prioritizedArticles.concat(articlesFiltered).slice(0, 3)
    : articlesFiltered.slice(0, 3)

  if (!articlesToShow.length) {
    return ""
    // return <p className="c-content-header -small">No articles available.</p>
  }

  articlesToShow.sort(
    (a, b) =>
      new Date(b.publishedDate).valueOf() - new Date(a.publishedDate).valueOf(),
  )

  return (
    <section id={componentId} className="o-row">
      <h2 className="c-content-header -small">{headline ? headline : title}</h2>
      <div className="c-articles-teaser o-wrapper">
        {articlesToShow.map(item => (
          <ArticleTeasers article={item} key={item.id} />
        ))}
      </div>
    </section>
  )
}

export default ArticlesTeaser
